// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"2f98f44b","632":"33b567f3","751":"c0de779c"}[chunkId] + ".chunk.js";
};